var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAzureArtifacts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_47_15430)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.0268 62.3189H18.2918C17.1644 62.3189 16.2411 61.3952 16.2411 60.2576V40.8602C16.2411 39.7226 17.1644 38.8087 18.2918 38.8087H34.0268V62.3189Z",
    fill: "#B41055"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2501 62.3189H54.5829V38.8087H61.2501C62.3581 38.8087 63.262 39.7129 63.262 40.8214V60.3062C63.262 61.4146 62.3581 62.3189 61.2501 62.3189Z",
    fill: "#E86299"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1719 62.3189H55.4954V38.8087H31.9949V60.141C31.9949 61.3368 32.9668 62.3189 34.1719 62.3189Z",
    fill: "#F173A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.358 15.2985H26.3782C25.2119 15.2985 24.2691 16.2416 24.2691 17.4084V38.8087H55.4671V17.4084C55.4671 16.2416 54.5243 15.2985 53.358 15.2985Z",
    fill: "#C12664"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6433 15.2985H26.3782C25.2119 15.2985 24.2691 16.2416 24.2691 17.4084V38.8087H47.6433V15.2985Z",
    fill: "#CF3071"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0015 23.0754H33.9196C32.8504 23.0754 31.9758 22.2004 31.9758 21.1308C31.9758 20.0613 32.8504 19.1862 33.9196 19.1862H38.0015C39.0707 19.1862 39.9453 20.0613 39.9453 21.1308C39.9453 22.2004 39.0804 23.0754 38.0015 23.0754Z",
    fill: "#B5205C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5928 52.5077H35.9592V54.5009H47.5928V52.5077Z",
    fill: "#FE90BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5778 56.4643H35.9592V58.4575H42.5778V56.4643Z",
    fill: "#FE90BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7004 46.7029H41.8225C40.7049 46.7029 39.801 45.7987 39.801 44.6806C39.801 43.5624 40.7049 42.6582 41.8225 42.6582H45.7004C46.8182 42.6582 47.722 43.5624 47.722 44.6806C47.722 45.7987 46.8182 46.7029 45.7004 46.7029Z",
    fill: "#CB2E6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9236 46.7029H26.0458C24.9281 46.7029 24.0242 45.7987 24.0242 44.6806C24.0242 43.5624 24.9281 42.6582 26.0458 42.6582H29.9236C31.0413 42.6582 31.9452 43.5624 31.9452 44.6806C31.9452 45.7987 31.0413 46.7029 29.9236 46.7029Z",
    fill: "#900740"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_47_15430"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(16 15)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzureArtifacts);
export default __webpack_public_path__ + "static/media/azure-artifacts.287ca1c945f752165317ba3fffa8ac72.svg";
export { ForwardRef as ReactComponent };